import { Box } from '@mui/material';
import { useMemo } from 'react';

import { Project } from '@work4all/models/lib/Classes/Project.entity';

import { formatAsFloat } from '@work4all/utils';

import { useProjectPlanningData } from './planning-columns/components/ProjectPlanningDataProvider';

export type ProjectPlannedTimesCellProps = {
  children?: React.ReactNode;
  value: string | number;
  row?: {
    original: Project;
  };
};

export const ProjectPlannedTimesCell = (
  props: ProjectPlannedTimesCellProps
) => {
  const { appointmentList } = useProjectPlanningData();

  const project = props.row?.original;

  const allProjectIds = useMemo(() => {
    if (!project) return [];
    return [
      project.id,
      ...(project.childProjects || []).map((pr) => pr?.id),
    ].filter(Boolean);
  }, [project]);

  const relevantAppointments = useMemo(() => {
    return appointmentList.filter((app) => {
      return allProjectIds.includes(app.projectId);
    });
  }, [appointmentList, allProjectIds]);

  const plannedList = useMemo(() => {
    return relevantAppointments.map((app) => app.projectProcessDuration || 0);
  }, [relevantAppointments]);

  const planned = useMemo(() => {
    if (plannedList.length === 0) {
      return null;
    }
    return plannedList.reduce((a, b) => a + b, 0);
  }, [plannedList]);

  if (!project || !planned) {
    return null;
  }

  const formattedValue =
    formatAsFloat(planned, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    }) + ' h';

  return <Box textAlign="right">{formattedValue}</Box>;
};
